// extracted by mini-css-extract-plugin
export default {"container":"CallCenterInventoryIssues_container__AtaDd"};